export default from './DesktopMenu';



// WEBPACK FOOTER //
// ./src/layouts/AppLayout/components/Menu/components/DesktopMenu/index.js